module.exports = __webpack_public_path__ + "static/media/penghu.848ebca5.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/penghu.png
 ** module id = 465
 ** module chunks = 0
 **/